import { ReviewsDetailsContainer } from '../ReviewsDetails/ReviewsDetails';
import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { trackReviewsTeaserView } from './tracking';
import { ReviewsTeaserContainer } from '../ReviewsTeaser/ReviewsTeaser';
import { Responsive } from '@cian/ui-kit';
import { ReviewsTeaserMobileContainer } from '../ReviewsTeaserMobile';

export const Reviews = () => {
  const trackingReviewsTeaserView = React.useCallback(() => {
    trackReviewsTeaserView();
  }, []);

  return (
    <>
      <ActionAfterViewed callback={trackingReviewsTeaserView}>
        <>
          <Responsive desktop>
            <ReviewsTeaserContainer />
          </Responsive>
          <Responsive phone tablet>
            <ReviewsTeaserMobileContainer />
          </Responsive>
        </>
      </ActionAfterViewed>

      <ReviewsDetailsContainer />
    </>
  );
};
